const initialState = {
  query: ""
}

export function searchbar(state = initialState, action) {
  switch(action.type) {
    case SVGUnitTypes.SEARCHBAR_NEW_QUERY:
    return {
      ...state,
      query: action.payload
    }
    default:
    return state
  }
}